import * as Icons from 'flowbite-react-icons/outline'
import { FlowbiteIconProps } from 'node_modules/flowbite-react-icons/dist/types/types'
interface IProps {
  iconType?: string
  className?: string
  iconClassName?: string
}

type FlowbiteIcon =
  | React.ForwardRefExoticComponent<
      Omit<FlowbiteIconProps, 'ref'> & React.RefAttributes<SVGSVGElement>
    >
  | undefined

export const FlowiteIconComponent = ({ iconType, className = '', iconClassName = '' }: IProps) => {
  const IconComponent: FlowbiteIcon = Icons[iconType as keyof typeof Icons]
  return <div className={`ml-1 ${className}`}>{IconComponent && <IconComponent className={iconClassName} />}</div>
}

export default FlowiteIconComponent
